import { useMemo } from 'react';

import type { EditorClassificationTagWrapperProps } from '../EditorComponentsV2/EditorClassificationTagWrapper';

export const useShouldRenderEditorActionBarClassificationPlaceholder = (
	props: EditorClassificationTagWrapperProps,
): boolean => {
	const { isDataClassificationEnabledForOrg, contentClassificationMetadata } = props;

	const { hasNoClassification, contentLevelLoading, spaceLevelLoading } =
		contentClassificationMetadata;

	return useMemo(() => {
		if (!isDataClassificationEnabledForOrg) return false;
		if (hasNoClassification) return false;
		if (contentLevelLoading || spaceLevelLoading) return false;
		return true;
	}, [
		contentLevelLoading,
		hasNoClassification,
		isDataClassificationEnabledForOrg,
		spaceLevelLoading,
	]);
};
